import "./oneSignalBootstrap";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.scss";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ReactPWAInstallProvider from "react-pwa-install";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
root.render(
  <ReactPWAInstallProvider enableLogging>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </ReactPWAInstallProvider>
);

reportWebVitals();

// serviceWorkerRegistration.register();
